module.exports = require("crypto");


//////////////////
// WEBPACK FOOTER
// external "crypto"
// module id = 6
// module chunks = 0